import { AuthUser } from '@/modules/auth/models/AuthUser';
import { MeetingType } from '@/modules/meeting/constants/MeetingType';
import type { Component } from 'vue';
import { LoadComponentService } from '/@/modules/core/app/services/LoadComponentService';

export class MeetingSchedulerModalComponentFactory {
  static async build(type: string, authUser: AuthUser | null = null): Promise<Component> {
    return LoadComponentService.load(this.getComponent(type, authUser));
  }

  static getComponent(type: string, authUser: AuthUser | null): Promise<Component> | undefined {
    switch (type) {
      case MeetingType.BASIC_SUPPORT.key:
        return import(
          '../components/stateful/meetingscheduler/BasicSupportMeetingSchedulerModal.vue'
        );

      case MeetingType.INTAKE.key:
        return import('../components/stateful/meetingscheduler/IntakeMeetingSchedulerModal.vue');

      case MeetingType.GUIDANCE.key:
        return import('../components/stateful/meetingscheduler/GuidanceMeetingSchedulerModal.vue');

      case MeetingType.WILL_REVIEW.key:
        return import(
          '../components/stateful/meetingscheduler/WillReviewMeetingSchedulerModal.vue'
        );

      case MeetingType.ANNUAL_REVIEW.key:
        return import(
          '../components/stateful/meetingscheduler/AnnualReviewMeetingSchedulerModal.vue'
        );

      case MeetingType.WILL_NOTARIZATION.key:
      case MeetingType.PROTECTION_MANDATE_NOTARIZATION.key:
      case MeetingType.WILL_AND_PROTECTION_MANDATE_NOTARIZATION.key:
        return import(
          '../components/stateful/meetingscheduler/NotarizationMeetingSchedulerModal.vue'
        );

      case MeetingType.REFERRAL_CONSULT.key:
      case MeetingType.REFERRAL_CONSULT_SETTLEMENT.key:
        if (authUser?.permission?.canAccessHeadlessCalendlyBooking) {
          return import('../components/stateful/MeetingAvailabilitiesPickerModal.vue');
        }

        return import(
          '../components/stateful/meetingscheduler/slim/ReferralConsultSlimMeetingShedulerModal.vue'
        );
      case MeetingType.FREE_CONSULT.key:
      case MeetingType.SETTLEMENT_CONSULT.key:
        return import('../components/stateful/meetingscheduler/FreeConsultSchedulerModal.vue');

      default:
        return undefined;
    }
  }
}
